import { SnapStage } from "../components/landing/stage/SnapStage";
import { Pager } from "../components/landing/stage/Pager";
import { Header } from "../components/landing/Header";
import { Hero } from "../components/landing/Hero";
import { FamilyCircle } from "../components/landing/FamilyCircle";
import { WhatsOnTheList } from "../components/landing/WhatsOnTheList";
import { HowItWorks } from "../components/landing/HowItWorks";
import { RealMoments } from "../components/landing/RealMoments";
import { Security } from "../components/landing/Security";
import { FAQ } from "../components/landing/FAQ";
import { GetStarted } from "../components/landing/GetStarted";
import { BetaFeedback } from "../components/landing/BetaFeedback";

/**
 * The landing page is a stack of full-screen scenes that snap one at a time;
 * each scene plays its own entrance once the page settles on it (see
 * components/landing/stage). The footer lives inside the last scene so the
 * final snap point still reaches it.
 */
export function Landing() {
  return (
    <SnapStage>
      <div className="bg-white text-neutral-900">
        <Header />
        <main>
          <Hero />
          <FamilyCircle />
          <WhatsOnTheList />
          <HowItWorks />
          <RealMoments />
          <Security />
          <FAQ />
          <GetStarted />
          <BetaFeedback />
        </main>
        {/* After <main>, so keyboard users reach the hero before nine dot buttons. */}
        <Pager />
      </div>
    </SnapStage>
  );
}
